import Reflux from 'reflux'

export default Reflux.createActions([
  'load', //(sensorId, timeframe, [graphType], [openerId])
  'close' //()
])
